module.exports = __webpack_public_path__ + "img/kn.e9216d17.svg";